// Generated by purs version 0.15.15
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var readErrorBody = function (response) {
    return Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
        return Ouroboros_Services_FFI_Http.responseText(response);
    })(function (v) {
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Response body unavailable"),
            statusCode: Data_Maybe.Nothing.value
        };
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Network error"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var errorFromStatus = function (status) {
    return function (message) {
        var statusCode = new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)));
        var cleaned = Data_String_Common.trim(message);
        var fallback = (function () {
            var $8 = cleaned === "";
            if ($8) {
                return "Request failed";
            };
            return cleaned;
        })();
        var $9 = status === 400;
        if ($9) {
            return {
                type: "BadRequest",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        var $10 = status === 404;
        if ($10) {
            return {
                type: "NotFound",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
            statusCode: statusCode
        };
    };
};
var requestOk = function (path) {
    return function (init) {
        return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(Ouroboros_Services_FFI_Env.apiUrl + path)(init);
        })(function (v) {
            return networkError;
        }))(function (response) {
            var $11 = Ouroboros_Services_FFI_Http.responseOk(response);
            if ($11) {
                return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
            };
            return Ouroboros_Services_FFI_TaskEither.chain(readErrorBody(response))(function (body) {
                return Ouroboros_Services_FFI_TaskEither.left(errorFromStatus(Ouroboros_Services_FFI_Http.responseStatus(response))(body));
            });
        });
    };
};
var createDefaultEmailValidationClient = {
    verify: function (token) {
        return requestOk("/v1/auth/email-validation")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign({
            token: token
        })));
    }
};
export {
    createDefaultEmailValidationClient
};
//# sourceMappingURL=index.js.map
